import axios from "axios";
import React, { useEffect } from "react";
import GetServerAddress from "../../functions/GetServerAddress";

export function Get_One_Choose_Fields_From_MongoDB(
  dbName,
  collctiontext,
  id,
  fields,
  setdata,
  logout
) {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() +
          "api/consultant/Get_One_Choose_Fields_From_MongoDB",
        {
          dbName: dbName,
          collctiontext: collctiontext,
          id: id,
          fields: fields,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("ConsultantToken")}`, // Include the JWT token in the
            username: localStorage.getItem("Consultant_id"),
            activitylog: "No",
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();

        return; // Stop further execution in case of invalid auth token
      }
      //Check if nothing found
      if (response.data.data.length === 0) {
        window.alert(
          "Error, No data found matching your search. Please try again or get Admin support"
        );
        console.log(
          "Error, No data found matching your search. Please try again or get Admin support"
        );
        setdata({}); // Update your state with the fetched data
      } else {
        setdata(response.data.data[0]); // Update your state with the fetched data
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };

  fetchData();
} // Empty dependency array means this effect runs only once
